import { clean } from "rut.js";
import { pipe } from "./functions";

const addHyphen = (rut) => (rut ? `${rut.slice(0, -1)}-${rut.slice(-1)}` : rut);

const validatePhoneBase = (l, prefix) => (phone) => {
	if (phone === null) return true;
	if (
		new RegExp(`${prefix ? "\\+" : ""}[0-9]{${l}}`).test(phone) &&
		(prefix ? String(phone).slice(1, 2) !== "0" : true)
	) {
		return true;
	}
	return false;
};
const validatePhoneBaseCL = (l, prefix) => (phone, required) => {
	if (phone === null) return true;

	if (!required && (!phone || phone.length <= 2)) return true;

	const includeCodePostal = String(phone).slice(0, 2) === "56";

	if (
		phone && phone.length <= includeCodePostal
			? l + 2
			: l &&
			  phone &&
			  phone.charAt(2) === "9" &&
			  new RegExp(
					`${prefix ? "\\+" : ""}[0-9]{${
						includeCodePostal ? l + 2 : l
					}}`
			  ).test(phone) &&
			  (prefix ? String(phone).slice(1, 2) !== "0" : true)
	) {
		return true;
	}
	return false;
};

export const validatePhone = validatePhoneBase(11, true);
export const validateShortPhone = validatePhoneBase(9, false);
export const validateShortPhoneCl = validatePhoneBaseCL(9, false);

export const formatPhone = (phone) => {
	if (phone === null) return phone;
	if (String(phone).slice(0, 1) === "+") return phone.replace(/[^0-9+]/g, "");
	return "+" + String(phone).replace(/[^0-9+]/g, "");
};

export const formatPhoneWithoutCountryCode = (phone) => {
	if (phone === null) return null;
	const phone2 = String(phone).slice(0, Math.min(phone.length, 9));
	return String(phone2).replace(/[^0-9+]/g, "");
};

export { validate } from "rut.js";

export default pipe(clean, addHyphen);
